import {all, call, fork, put, takeEvery, takeLatest} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import ContactActions from '../Contact/actions';
import AppActions from '../App/actions';
import {get} from 'bukku/shared/ApiService';
import {CustomFieldHelper} from 'bukku/shared/CustomFieldHelper';
import {t} from "@lingui/macro";
import { exportReportByPostForm } from './helper';

// Read report
export function* readReportRequest() {
    yield takeLatest([actions.REPORT_READ_REQUEST, actions.REPORT_RESET_STATE], function* ({
        reportType, request, type,
    }, context) {
        if (type === actions.REPORT_RESET_STATE)
            return;

        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/reports/${reportType}`, request, context);
            const data = yield response.data;

            // get custom field data for transaction list report
            let customFieldsResponse, customFieldData;
            if (reportType === 'transaction_list' && request.field_ids.length) {
                customFieldsResponse = yield call(get, '/reports/transaction_list/fields', request, context);
                customFieldData = customFieldsResponse.data.transactions;
            }

            // for item sales collection report, only <=5 products may be selected
            if (reportType === 'item_sales_collection' && request.product_ids.length > 5)
                throw Error(t`You may only select a maximum of 5 products.`);

            // OK
            yield put({
                type: actions.REPORT_READ_SUCCESS,
                reportData: data,
                reportType,

                // for transaction list custom fields columns
                reportCustomFields: customFieldData,
                requestedFieldKeys: CustomFieldHelper.getFieldKeys(request.field_ids),
            });

            // Some reports, eg Debtor/Creditor Ledger, Aged Details, have contact person select, which is dependent on contact selected.
            // So, we need to set the contact_id in redux store, so that ContactPerson select's componentDidUpdate can detect changes and read contact person list if needed
            if (request.contact_id) {
                yield put({
                    type: ContactActions.SET_CONTACT_ID,
                    contactId: request.contact_id,
                });
            }
        }
        catch (error) {
            yield put({
                type: actions.REPORT_READ_FAILURE,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readReportSuccess() {
    yield takeEvery(actions.REPORT_READ_SUCCESS, () => {});
}
export function* readReportFailure() {
    yield takeEvery(actions.REPORT_READ_FAILURE, function* ({ error }) {
        yield message.error(error.message);
    });
}

// READ TRANSACTION LIST REPORT'S CUSTOM FIELDS
export function* readReportCustomFieldsRequest() {
    yield takeLatest([
        actions.REPORT_READ_CUSTOM_FIELDS_REQUEST,
        actions.REPORT_RESET_STATE,
    ], function* ({ request, type }, context) {
        if (type === actions.REPORT_RESET_STATE)
            return;

        try {
            const response = yield call(get, '/reports/transaction_list/fields', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.REPORT_READ_CUSTOM_FIELDS_SUCCESS,
                reportCustomFields: data.transactions,
                requestedFieldKeys: CustomFieldHelper.getFieldKeys(request.field_ids),

            });
        }
        catch (error) {
            yield put({
                type: actions.REPORT_READ_CUSTOM_FIELDS_ERROR,
                error,
            });
        }
    });
}
export function* readReportCustomFieldsSuccess() {
    yield takeEvery(actions.REPORT_READ_CUSTOM_FIELDS_SUCCESS, () => {});
}
export function* readReportCustomFieldsError() {
    yield takeEvery(actions.REPORT_READ_CUSTOM_FIELDS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export function* exportReportRequest() {
    yield takeLatest(actions.REPORT_EXPORT_REQUEST, function* ({ reportType, format, request, label }) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });

            // export report by using form with method="POST"
            exportReportByPostForm(reportType, format, request, label);

            // OK
            yield put({
                type: actions.REPORT_EXPORT_SUCCESS,
            });

            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
        catch (error) {
            yield put({
                type: actions.REPORT_EXPORT_ERROR,
                error,
            });
        }
    },
    );
}

export function* exportReportSuccess() {
    yield takeEvery(actions.REPORT_EXPORT_SUCCESS, () => {
    });
}
export function* exportReportError() {
    yield takeEvery(actions.REPORT_EXPORT_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(readReportRequest),
        fork(readReportSuccess),
        fork(readReportFailure),
        fork(readReportCustomFieldsRequest),
        fork(readReportCustomFieldsSuccess),
        fork(readReportCustomFieldsError),
        fork(exportReportRequest),
        fork(exportReportSuccess),
        fork(exportReportError),
    ]);
}
